import { render, staticRenderFns } from "./carousel-item.pug?vue&type=template&id=5c61004f&lang=pug&external"
import script from "./carousel-item.js?vue&type=script&lang=js&external"
export * from "./carousel-item.js?vue&type=script&lang=js&external"
import style0 from "./carousel-item.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports